import { defineQuery } from 'next-sanity'
import { videoRef } from './fragments/video'

export const quizBySlugQuery = defineQuery(`
  *[_type == "quiz" && slug.current == $slug]{
    ...,
    "topicTheme": topic[0]->{
      _id,
      "light": colors.light,
      "background": colors.background,
      "promoted": colors.promoted,
      "dark": colors.dark,
      "illustration": {
        "aspect": illustration.png.asset->metadata.dimensions.aspectRatio,
        "path": illustration.png.asset->url,
        "webp": illustration.webp.asset->url
      }
    },
    questions[] {
      ...,
      media[0] {
        ...,
        _type == 'image' => {
          ...,
          "dimensions": asset->metadata.dimensions,
          "lqip": asset->metadata.lqip,
          "palette": asset->metadata.palette,
          "hasAlpha": asset->metadata.hasAlpha
        },
        ${videoRef}
      }
    }
  } | order(_updatedAt desc)[0]
`)
